module.exports = __webpack_public_path__ + "static/media/nova_scotia.80a79a33.png";